<template>
  <div class="loadContent">
    <svg-icon class="svgicon" name="Warning-face" />
    <!-- Add a new card or bank before you top up -->
    <span>{{ $t('topUpAdminAddCardInfo') }}</span>
  </div>
</template>

<script>
export default {
  name: 'LoadContent'
}
</script>

<style lang="scss" scoped>
.loadContent {
  margin-top: 36px;
  display: flex;

  .svgicon {
    color: #b2b2b2;
  }

  span {
    display: inline-block;
    margin-left: 8px;
    color: #b2b2b2;
  }
}
</style>
